import { $, $$, on } from './utils';
var kid = 0;
function min(cntr) {
    return parseInt(cntr.dataset.min || '0', 10);
}
function max(cntr) {
    return parseInt(cntr.dataset.max || '0', 10) || Infinity;
}
function addRow(cntr) {
    var tmpl = $(cntr.dataset.multiAssignTemplate);
    if (!tmpl)
        throw Error("Unexpected: ".concat(cntr.dataset.multiAssignTemplate));
    var index = "NEW".concat(++kid);
    var content = tmpl.content.firstElementChild.cloneNode(true);
    content.querySelectorAll('[name],[id],[for]').forEach(function (elem) {
        for (var _i = 0, _a = ['id', 'name', 'for']; _i < _a.length; _i++) {
            var att = _a[_i];
            var attVal = elem.getAttribute(att);
            if (attVal)
                elem.setAttribute(att, attVal.replace(/__ID__/g, index));
        }
    });
    cntr.append(content);
    content.querySelectorAll('.tinymce').forEach(function (e) {
        e.dispatchEvent(new Event('tinymceinit', { bubbles: true, cancelable: true }));
    });
    updateButtons(cntr);
}
function setDisabled(elems, disabled) {
    elems === null || elems === void 0 ? void 0 : elems.forEach(function (elem) { return (elem.disabled = disabled); });
}
function updateButtons(cntr) {
    var _a, _b;
    var count = cntr.childElementCount;
    var minAppeared = count <= min(cntr);
    var maxAppeared = count >= max(cntr);
    setDisabled(cntr.querySelectorAll('[data-multi-assign-remove]'), minAppeared);
    setDisabled($$("[data-multi-assign-add=\"".concat(cntr.id, "\"]")), maxAppeared);
    setDisabled(cntr.querySelectorAll('[data-multi-assign-up],[data-multi-assign-down]'), false);
    setDisabled((_a = cntr.firstElementChild) === null || _a === void 0 ? void 0 : _a.querySelectorAll('[data-multi-assign-up]'), true);
    setDisabled((_b = cntr.lastElementChild) === null || _b === void 0 ? void 0 : _b.querySelectorAll('[data-multi-assign-down]'), true);
}
on('click', '[data-multi-assign-add] button', function (ev) {
    var fs = ev.currentTarget.closest('[data-multi-assign-add]');
    var cntr = $(fs.dataset.multiAssignAdd);
    if (cntr.childElementCount >= max(cntr))
        return;
    addRow(cntr);
});
on('click', '[data-multi-assign-remove]', function (ev) {
    var _a;
    var elem = ev.currentTarget;
    var cntr = elem.closest('.multi-assign');
    if (cntr.childElementCount <= min(cntr))
        return;
    (_a = Array.from(cntr.children)
        .find(function (node) { return node.contains(elem); })) === null || _a === void 0 ? void 0 : _a.remove();
    updateButtons(cntr);
});
on('click', '[data-multi-assign-up]', function (ev) {
    var elem = ev.currentTarget;
    var cntr = elem.closest('.multi-assign');
    var child = Array.from(cntr.children).find(function (node) { return node.contains(elem); });
    var prev = child.previousElementSibling;
    if (prev)
        cntr.insertBefore(child, prev);
    updateButtons(cntr);
});
on('click', '[data-multi-assign-down]', function (ev) {
    var elem = ev.currentTarget;
    var cntr = elem.closest('.multi-assign');
    var child = Array.from(cntr.children).find(function (node) { return node.contains(elem); });
    var next = child.nextElementSibling;
    if (next)
        cntr.insertBefore(child, next.nextElementSibling);
    updateButtons(cntr);
});
$$('.multi-assign').forEach(updateButtons);
